// Defers work until the first real user gesture. Crawlers and Lighthouse never
// gesture, so deferred work (RTDB presence, carousel auto-play) stays out of
// audit traces entirely; real users trigger it within their first scroll or
// pointer move.
const EVENTS = ["pointerdown", "pointermove", "keydown", "wheel", "touchstart", "scroll"];

let fired = false;
const queue = new Set();

function fire() {
  if (fired) return;
  fired = true;
  EVENTS.forEach((e) => window.removeEventListener(e, fire));
  queue.forEach((cb) => {
    try {
      cb();
    } catch (err) {
      console.error("firstInteraction callback failed:", err);
    }
  });
  queue.clear();
}

EVENTS.forEach((e) => window.addEventListener(e, fire, { passive: true }));

export function onFirstInteraction(cb) {
  if (fired) cb();
  else queue.add(cb);
}

export function hasInteracted() {
  return fired;
}
